import { IdNumberValidatorFactory } from "src/contexts/_shared/domain/validation/IdNumberValidatorFactory";
import { IdNumberCountries } from "src/contexts/documentationArea/domain/IdNumberCountries";
import { DocumentationAreaTypes } from "src/contexts/documentationArea/domain/DocumentationAreaTypes";
import { IdNumberTypes } from "src/contexts/documentationArea/domain/IdNumberTypes";

export const validateRepresentativeIdNumber = (
  idNumber: string,
  idNumberType: IdNumberTypes | undefined,
  country: IdNumberCountries,
): boolean => {
  if (!idNumberType) return false;
  const validator = IdNumberValidatorFactory.create(country, DocumentationAreaTypes.INDIVIDUAL);
  return validator.validate({ value: idNumber, idNumberType });
};

export const validateCompanyNif = (
  companyNif: string,
  idNumberType: IdNumberTypes | undefined,
  country: IdNumberCountries,
): boolean => {
  if (!companyNif) return false;
  const validator = IdNumberValidatorFactory.create(country, DocumentationAreaTypes.COMPANY);
  return validator.validate(companyNif.trim());
};
